// import { Navigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// const PublicRoute = ({ children }) => {
//   const { isAuthenticated = false, loading = false, profileComplete = false } = useSelector(
//     (state) => state.auth || {}
//   );
//   const location = useLocation(); // 👈 add this

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   if (isAuthenticated) {
//     if (!profileComplete) {
//       return <Navigate to="/user-details" replace />;
//     }
//     // 👇 Respect the original destination if redirected here from a protected route
//     const from = location.state?.from?.pathname;
//     return <Navigate to={from || '/home'} replace />;
//   }

//   return children;
// };

// export default PublicRoute;

// src/components/auth/PublicRoute.jsx
// ─────────────────────────────────────────────────────────────────────────────
// Updated to let authenticated users view the landing page (/).
// Previously it immediately redirected logged-in users away from "/",
// but now the landing page IS the root, so we need a softer rule:
//   - "/" → always allow (authenticated users can still see the landing page,
//            they will just see "Sign In" replaced with their dashboard link)
//   - "/login", "/register", etc → redirect authenticated users to /home
// ─────────────────────────────────────────────────────────────────────────────
// src/components/auth/PublicRoute.jsx
// ─────────────────────────────────────────────────────────────────────────────
// Updated to let authenticated users view the landing page (/).
// Previously it immediately redirected logged-in users away from "/",
// but now the landing page IS the root, so we need a softer rule:
//   - "/" → always allow (authenticated users can still see the landing page,
//            they will just see "Sign In" replaced with their dashboard link)
//   - "/login", "/register", etc → redirect authenticated users to /home
// ─────────────────────────────────────────────────────────────────────────────


import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export default function PublicRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const profileComplete  = useSelector((state) => state.auth.profileComplete);
  const { pathname } = useLocation();

  // Allow authenticated users to visit the landing page — they just see
  // "Go to Dashboard" instead of "Get Started Free".
  if (pathname === '/') return children;

  // All other public routes (/login, /register, etc.)
  // redirect authenticated users to the appropriate page.
  if (isAuthenticated) {
    return <Navigate to={profileComplete ? '/home' : '/user-details'} replace />;
  }

  return children;
}